import { onBeforeUnmount } from "vue";
import { openHeaderPopovers } from "@/stores/CanvasLayoutState";

/**
 * Signale qu'une popup de l'en-tête (légende, échelle) est ouverte : la mise
 * en page automatique ne replie / déplie pas la légende pendant ce temps, ce
 * qui démonterait ou décalerait la popup sous le doigt.
 *
 * À brancher sur les événements `show` / `hide` de l'el-popover.
 */
export function useHeaderPopoverLock() {
  let open = false;

  function onShow() {
    if (open) return;
    open = true;
    openHeaderPopovers.value++;
  }

  function onHide() {
    if (!open) return;
    open = false;
    openHeaderPopovers.value--;
  }

  // Démontée popup ouverte : sans ça, le verrou resterait posé.
  onBeforeUnmount(onHide);

  return { onShow, onHide };
}
